import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Create Supabase client with auth settings optimized for development/testing
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    // Disable automatic redirect for email confirmation in development
    detectSessionInUrl: false,
    // Allow sign in without email confirmation for testing
    persistSession: true,
    // Enable auto refresh token
    autoRefreshToken: true
  }
});